import { STAFF_ROLES } from "@shared/core/types";
import type { WebModule } from "../../core/modules";
import { CandidateDocumentsPage } from "./routes/candidate-documents";
import { ExpirationsPage } from "./routes/expirations";

const xDocuments: WebModule = {
  name: "x-documents",
  routes: [
    { path: "/candidats/:id/pieces", element: <CandidateDocumentsPage /> },
    { path: "/pieces/expirations", element: <ExpirationsPage />, roles: STAFF_ROLES },
  ],
  nav: [
    {
      title: "Pièces",
      order: 20,
      roles: STAFF_ROLES,
      items: [{ to: "/pieces/expirations", label: "Expirations", icon: "clock", end: true }],
    },
  ],
};

export default xDocuments;
